import request from "../utils/request";

export const list = (data) => request.get("/api/income", data);
export const get = (id) => request.get(`/api/income/${id}`);
export const remove = (id) => request.del(`/api/income/${id}`);
export const pay = (id) => request.put(`/api/income/${id}`);
export const calculate = (data) => request.post("/api/income/calculate", data);
export const update = (data) => request.post(`/api/income/update/${data._id}`, data);